import _isEmpty from "lodash/isEmpty";
import { FocusZone, getElementType, getUnhandledProps, unstable_getAccessibility as getAccessibility, unstable_getStyles as getStyles, useTelemetry } from '@fluentui/react-bindings';
import { emptyTheme } from '@fluentui/styles';
import logProviderMissingWarning from './providerMissingHandler';

var renderComponent = function renderComponent(config, context) {
  var className = config.className,
      displayName = config.displayName,
      handledProps = config.handledProps,
      props = config.props,
      state = config.state,
      actionHandlers = config.actionHandlers,
      render = config.render,
      _config$saveDebug = config.saveDebug,
      saveDebug = _config$saveDebug === void 0 ? function () {} : _config$saveDebug;

  if (_isEmpty(context)) {
    logProviderMissingWarning();
  }

  var _useTelemetry = useTelemetry(displayName, context.telemetry),
      setStart = _useTelemetry.setStart,
      setEnd = _useTelemetry.setEnd;

  var rtl = context.rtl || false;
  setStart();
  var ElementType = getElementType(props);
  var unhandledProps = getUnhandledProps(handledProps, props);
  var stateAndProps = Object.assign({}, state, {}, props);
  var accessibility = getAccessibility(displayName, props.accessibility, stateAndProps, rtl, actionHandlers);

  var _getStyles = getStyles({
    className: className,
    disableAnimations: context.disableAnimations || false,
    displayName: displayName,
    props: stateAndProps,
    renderer: context.renderer || {
      renderRule: function renderRule() {
        return '';
      }
    },
    rtl: rtl,
    saveDebug: saveDebug,
    theme: context.theme || emptyTheme,
    performance: Object.assign({}, context.performance, {
      // we cannot enable caching for class components
      enableStylesCaching: false,
      enableBooleanVariablesCaching: false
    })
  }),
      classes = _getStyles.classes,
      variables = _getStyles.variables,
      styles = _getStyles.styles,
      theme = _getStyles.theme;

  var resolvedConfig = {
    ElementType: ElementType,
    unhandledProps: unhandledProps,
    classes: classes,
    variables: variables,
    styles: styles,
    accessibility: accessibility,
    rtl: rtl,
    theme: theme
  };

  if (accessibility.focusZone) {
    var originalElementType = resolvedConfig.ElementType;
    resolvedConfig.ElementType = FocusZone;
    resolvedConfig.unhandledProps = Object.assign({}, resolvedConfig.unhandledProps, {}, accessibility.focusZone.props);
    resolvedConfig.unhandledProps.as = originalElementType;
    resolvedConfig.unhandledProps.isRtl = resolvedConfig.rtl;
  }

  var element = render(resolvedConfig);
  setEnd();
  return element;
};

export default renderComponent;